import { UserDataActionTypes, SetUserData } from './ActionTypes';
import { IUserData } from 'Store/IUserData';

export const setUserData = (userData: IUserData): SetUserData => ({
    type: UserDataActionTypes.SetUserData as UserDataActionTypes.SetUserData,
    userData
});

export type UserDataAction = ReturnType<typeof setUserData >